import { type ComponentProps } from "react";

export const CloudyClearAtTime = (props: ComponentProps<"svg">) => (
  <svg
    width="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.6361 2V4.43513H19.6361V2H17.6361ZM30.0001 12.3639H27.5649L27.5649 14.3639H30.0001V12.3639ZM25.8687 8.03351L27.9776 6.81594L28.9776 8.54799L26.8687 9.76556L25.8687 8.03351ZM23.4521 3.02245L22.2346 5.13133L23.9666 6.13133L25.1842 4.02245L23.4521 3.02245ZM13.3057 6.13133L12.0881 4.02245L13.8202 3.02245L15.0377 5.13133L13.3057 6.13133ZM24.1536 13.3638C24.1536 14.5604 23.7766 15.6689 23.1351 16.5772C23.8565 16.632 24.5431 16.8111 25.1736 17.0931C25.7974 15.9922 26.1536 14.7196 26.1536 13.3638C26.1536 9.17971 22.7617 5.78784 18.5776 5.78784C15.5731 5.78784 12.9772 7.53678 11.7522 10.0721L11.761 10.0721C12.499 10.0721 13.217 10.1574 13.9057 10.3188C14.901 8.79489 16.6217 7.78784 18.5776 7.78784C21.6571 7.78784 24.1536 10.2843 24.1536 13.3638Z"
      fill="url(#paint0_linear_1554_20127)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 28L12.5411 27.9999V28L12.6971 28L22.9973 28H23C23.0014 28 23.0028 28 23.0043 28C25.6983 27.9976 28 25.7147 28 22.75C28 19.7838 25.6958 17.5 23 17.5C22.2698 17.5 21.5684 17.6675 20.9337 17.9708C20.8474 17.2839 20.685 16.6218 20.4555 15.9939L20.4577 15.993C19.2369 12.6095 16.0973 10.25 12.5 10.25C7.87115 10.25 4 14.1567 4 19.125C4 24.0933 7.87115 28 12.5 28ZM23.2414 29.9958C26.9956 29.864 30 26.6704 30 22.75C30 18.7459 26.866 15.5 23 15.5C22.8017 15.5 22.6053 15.5085 22.4111 15.5253C20.9766 11.2883 17.0809 8.25 12.5 8.25C6.70101 8.25 2 13.1189 2 19.125C2 25.1311 6.70101 30 12.5 30C12.5658 30 12.6315 29.9994 12.6971 29.9981V30H22.9949C22.9966 30 22.9983 30 23 30C23.0017 30 23.0034 30 23.0051 30H23.2414V29.9958Z"
      fill="url(#paint1_linear_1554_20127)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1554_20127"
        x1="20.8761"
        y1="2"
        x2="20.8761"
        y2="17.0931"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFC977" />
        <stop offset="1" stopColor="#E07256" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1554_20127"
        x1="16"
        y1="8.25"
        x2="16"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B2D4F7" />
        <stop offset="1" stopColor="#D9E2F3" />
      </linearGradient>
    </defs>
  </svg>
);
